module.exports = __webpack_public_path__ + "img/enter.aba50d4f.svg";